import ClientOrder from './modules/ClientOrderApi'

export default {
  ClientOrder,
}